import FormProps from './parts/FormProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class FormPropertiesProvider {

  constructor(propertiesPanel, translate) {

    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:SendTask')) {
          groups.push(createFormGroup(element, translate));
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

FormPropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "Form".
function createFormGroup(element, translate) {

  const formGroup = {
    id: 'form',
    label: translate('Form'),
    entries: FormProps(element),
    // tooltip: translate('Group tooltip')
  };

  return formGroup;
}
